export default {
  title: 'Info',
  sections: {
    work_schedule: 'Orari di apertura: ordini online',
    delivery_schedule: 'Orari di consegna',
    delivery_costs: 'Costi di consegna',
    website: 'Sito web',
  },
  labels: {
    delivery_fees: 'Importo min. - {{threshold}}, Commissione - {{fee}}',
  },
};
